






















































































import { Component, Vue } from "vue-property-decorator";
import { getArticles } from "@/api/articles";
import { IArticleData } from "@/api/types";
import Pagination from "@/components/Pagination/index.vue";

@Component({
  name: "Apparatus",
  components: {
    Pagination,
  },
})
export default class extends Vue {
  private formObj = {
    search: "",
  };
  private list: IArticleData[] = [];
  private listLoading = true;
  private listQuery = {
    page: 1,
    limit: 1,
  };
  private total: number = 1;
  private screen: boolean = false;
  private created() {
    this.getList();
  }
  private async getList() {
    this.listLoading = true;
    await getArticles(this.listQuery)
      .then((res) => {
        this.list = res.data.items;
        this.total = res.data.total;
        this.listLoading = false;
      })
      .catch(() => {
        this.list = [];
        this.listLoading = false;
      });
  }
  private handleCurrentChange(val: number) {
    console.log(`当前页: ${val}`);
  }
  private handleSelectionChange(val: any) {
    console.log(val);
  }
  private onSubmit() {
    this.getList();
  }
  private onScreen() {
    this.screen = true;
  }
}
